import React, { useEffect, useState } from 'react'
import { PageProps } from 'gatsby'
import queryString from 'query-string'
import Loadable from '@loadable/component'
import 'styles/normalize.css'
import { useStore } from 'stores/store'
import Layout from 'components/layout'

import WindowResizer from 'components/windowResizer'
import AssetsLoader from 'components/assetsLoader'

const LoadableVideo = Loadable(() => import('sections/video/embed'))

const EmbedPage = ({ location } : PageProps) => {
  const [withLogo, setWithLogo] = useState(true)
  const setEmbed = useStore(state => state.setEmbed)

  useEffect(() => {
    setEmbed()
  }, [])

  useEffect(() => {
    const query = queryString.parse(location.search)
    setWithLogo(!(query.logo && query.logo === 'false'))
  }, [location.search])

  return (
    <Layout>
      <LoadableVideo withLogo={withLogo} />
      <AssetsLoader />
      <WindowResizer />
    </Layout>
  )
}

export default EmbedPage
